<template>
    <div class="addmuludiv">
        <div class="quillclass">
            <div
                ref="quillEditorRef"
                :class="['maincontent']"
            >
                <div
                    v-html="EditData"
                    ref="edithtml"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    ref,
    onMounted,
    onBeforeUnmount,
    defineEmits,
    computed,
    nextTick,
    defineProps,
    watch,
    defineExpose
} from "vue";
import { ElInput, ElButton, ElBadge } from "element-plus";
import { useRoute } from "vue-router";
import { picAPI } from "@/api/api";
const route = useRoute();
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { ElMessage, ElMessageBox } from "element-plus";
import { ElLoading } from "element-plus";
import ImageResize from "quill-image-resize";
import QuillBetterTable from "quill-better-table";
import "quill-better-table/dist/quill-better-table.css";
const Role = localStorage.getItem("role");
const props = defineProps({
    quillcontent: {
        type: String,
        default: true
    }
});

const iseditshow = ref(true);
if (sessionStorage.ccashowedit === "0") {
    iseditshow.value = true;
} else {
    if (Role === "1") {
        iseditshow.value = true;
    } else {
        iseditshow.value = false;
    }
}
// 注册模块
Quill.register("modules/imageResize", ImageResize);
// 在组件中定义一个变量来存储上一个高亮的元素
const lastHighlightedElement = ref(null);
// 2. 创建一个移除高亮的方法
const removeHighlight = () => {
    if (lastHighlightedElement.value) {
        lastHighlightedElement.value.classList.remove("highlight-click");
    }
    lastHighlightedElement.value = null;
};

const quillEditorRef = ref(null);
// const toolbarOptions = ["bold", "italic", "underline", "strike"];
let QUILL = null;
const edithtml = ref(null);
const EditData = ref("");
const emits = defineEmits(["changesavestate"]);
const addToolbarTitles = () => {
    // 按钮功能和对应的 title 信息
    const titles = {
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        strike: "Strikethrough",
        link: "Insert Link",
        image: "Insert Image",
        header: "Header",
        list: "List",
        indent: "Indent",
        direction: "Text Direction",
        clean: "Remove Formatting"
    };

    // 查找工具栏中的按钮元素
    const toolbar = document.querySelector(".ql-toolbar");
    if (toolbar) {
        // 遍历工具栏中的所有按钮并设置 title
        toolbar.querySelectorAll("button").forEach((button) => {
            const format = button?.classList[0]?.replace("ql-", "");
            if (titles[format]) {
                button.setAttribute("title", titles[format]);
            }
        });
    }
};

let savedFormat = null;
// 记录初始内容和是否有用户编辑，用于外层判断是否需要二次确认
let initialHtml = "";
let hasUserEdited = false;

// 输入空格/换行等或粘贴含 URL 时，将 http(s) 地址自动设为 Quill link
const AUTO_LINK_MAX_SCAN = 8000;
const URL_IN_TEXT_RE = /https?:\/\/[^\s<>"']+/gi;

function shouldAttemptAutoLink(delta) {
    if (!delta?.ops) return false;
    for (const op of delta.ops) {
        if (typeof op.insert !== "string" || op.insert.length === 0) continue;
        const s = op.insert;
        if (/https?:\/\//i.test(s)) return true;
        const ch = s[s.length - 1];
        if (
            ch === " " ||
            ch === "\n" ||
            ch === "\t" ||
            ch === ")" ||
            ch === "]" ||
            ch === "}" ||
            ch === "," ||
            ch === ";" ||
            ch === "!" ||
            ch === "?" ||
            ch === "'" ||
            ch === '"' ||
            ch === "。" ||
            ch === "，"
        ) {
            return true;
        }
    }
    return false;
}

function applyAutoLinkIfNeeded(quill) {
    if (!quill) return;
    const range = quill.getSelection();
    if (!range || range.length > 0) return;
    const cursor = range.index;
    if (cursor < "https://".length) return;

    const scanStart = Math.max(0, cursor - AUTO_LINK_MAX_SCAN);
    const raw = quill.getText(scanStart, cursor - scanStart);
    const text = raw.replace(/\s+$/, "");
    if (!text || text.length < 8) return;

    URL_IN_TEXT_RE.lastIndex = 0;
    let last = null;
    let m;
    while ((m = URL_IN_TEXT_RE.exec(text)) !== null) {
        last = m;
    }
    if (!last) return;

    const url = last[0];
    const relStart = last.index;
    if (url.length < 8) return;

    const absStart = scanStart + relStart;
    const fmt = quill.getFormat(absStart, url.length);
    if (fmt.link) return;

    quill.formatText(absStart, url.length, "link", url, Quill.sources.API);
}

const initQuill = (content) => {
    const Block = Quill.import("blots/block");

    // 创建一个新的图片代码块 Blot
    class CodeBlockWithImage extends Block {
        static create(value) {
            const node = super.create(value);
            node.setAttribute("class", "ql-code-block-with-image");
            return node;
        }

        static formats(node) {
            return node.tagName === this.tagName ? true : undefined;
        }
    }

    CodeBlockWithImage.blotName = "code-block-with-image";
    CodeBlockWithImage.tagName = "pre";

    // 注册新的 Blot
    Quill.register(CodeBlockWithImage);

    // 添加样式
    const style = document.createElement("style");
    style.textContent = `
        .ql-code-block-with-image {
            background-color: #23241f;
            color: #f8f8f2;
            padding: 1em;
            margin: 0.5em 0;
            white-space: pre-wrap;
            font-family: monospace;
        }

        .ql-code-block-with-image img {
            max-width: 100%;
            height: auto;
            display: block;
        }
    `;
    document.head.appendChild(style);
    const fontSizeArr = ["14px", "16px", "18px", "20px", "22px", "24px", "26px"];
    // 创建自定义字体大小
    const Size = Quill.import("attributors/style/size");
    Size.whitelist = fontSizeArr; // 将默认的字体大小替换为自定义的数组
    Quill.register(Size, true);
    // 注册表格模块
    // 正确注册表格模块
    Quill.register(
        {
            "modules/better-table": QuillBetterTable
        },
        true
    );

    const toolbarOptions = [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        // ["code-block"],
        // ["code-block-with-image"], // 添加新的代码块类型
        // ["blockquote", "code-block"],
        ["link", "image"],
        // ["link", "image", "video", "formula"],

        // [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction

        [{ size: fontSizeArr }], // custom dropdown
        // [{ header: [1, 2, 3, 4, false] }],

        // 修改这一行，添加自定义颜色
        [
            {
                color: [
                    "#000000",
                    "#e60000",
                    "#ff9900",
                    "#ffff00",
                    "#008a00",
                    "#0066cc",
                    "#9933ff",
                    "#ffffff",
                    "#facccc",
                    "#ffebcc",
                    "#ffffcc",
                    "#cce8cc",
                    "#cce0f5",
                    "#ebd6ff",
                    "#bbbbbb",
                    "#f06666",
                    "#ffc266",
                    "#ffff66",
                    "#66b966",
                    "#66a3e0",
                    "#c285ff",
                    "#888888",
                    "#a10000",
                    "#b26b00",
                    "#b2b200",
                    "#006100",
                    "#0047b2",
                    "#6b24b2",
                    "#444444",
                    "#5c0000",
                    "#663d00",
                    "#666600",
                    "#003700",
                    "#002966",
                    "#3d1466",
                    // 添加你的自定义颜色
                    "#FF0000",
                    "#00FF00",
                    "#0000FF",
                    "#FF9900",
                    "#9933FF",
                    "#33CC33",
                    "#ff7010"
                ]
            },
            {
                background: [
                    // 同样的颜色列表
                    "#000000",
                    "#e60000",
                    "#ff9900",
                    "#ffff00",
                    "#008a00"

                    // ... 其他颜色
                ]
            }
        ],
        // [{ font: [] }],
        [{ align: [] }],

        ["clean"], // remove formatting button
        // 自定义图标“格式刷”
        ["format-brush"]
        // ["table"] // 添加表格按钮
    ];

    QUILL = new Quill(quillEditorRef.value, {
        modules: {
            keyboard: {
                bindings: {
                    // 空列表行上 Backspace：outdent 要求 offset===0，光标若在 <br> 后等位置会不匹配；
                    // 随后 handleBackspace 在 index===0 或 getLength()<=1 时空返回却仍 preventDefault，出现删不掉的 “1.”。
                    "list-empty-backspace-fix": {
                        key: "Backspace",
                        collapsed: true,
                        format: ["list"],
                        handler(range, context) {
                            const q = this.quill;
                            const [line] = q.getLine(range.index);
                            if (!line) return true;

                            const lineStart = line.offset();
                            const lineLen = line.length();
                            const inner = Math.max(0, lineLen - 1);
                            const lineText = q
                                .getText(lineStart, inner)
                                .replace(/\u200b/g, "")
                                .trim();
                            const isLineEmpty = lineText === "";

                            if (!isLineEmpty) return true;

                            const formats = { list: false };
                            if (context.format.indent != null) {
                                formats.indent = false;
                            }
                            q.formatLine(range.index, range.length, formats, Quill.sources.USER);
                            return false;
                        }
                    },
                    enter: {
                        key: "Enter", // 使用键名而不是键码
                        handler() {
                            // 获取当前选区
                            const range = this.quill.getSelection();
                            if (!range) return true;

                            // 列表（有序/无序/任务）：必须交给 Quill 默认 Enter（新项、空项退出列表等）。
                            // 本组件下行末 cloneNode 插入会破坏 <ol>/<li> 与 Delta 同步，出现删不掉的 “1.”。
                            const lineFormat = this.quill.getFormat(range);
                            if (lineFormat.list) {
                                return true;
                            }

                            // 获取当前行
                            const [line] = this.quill.getLine(range.index);
                            if (!line) return true;
                            const hasImage = line.domNode.querySelector("img");

                            if (hasImage) {
                                // 如果当前行包含图片，插入一个空行
                                this.quill.insertText(range.index, "\n");
                                this.quill.setSelection(range.index + 1);
                                return false;
                            }
                            // 判断光标是否在行末
                            const isAtLineEnd = range.index >= line.offset() + line.length() - 1;

                            if (isAtLineEnd) {
                                // 使用原来的逻辑 - 保留上一行样式
                                const currentNode = line.domNode;

                                // 创建一个新的节点，复制当前节点的完整结构
                                const newNode = currentNode.cloneNode(true);

                                // 清空新节点中的文本内容但保留结构
                                const clearTextContent = (node) => {
                                    Array.from(node.childNodes).forEach((child) => {
                                        if (child.nodeType === Node.TEXT_NODE) {
                                            child.textContent = "";
                                        } else if (child.nodeType === Node.ELEMENT_NODE) {
                                            if (child.tagName !== "BR") {
                                                clearTextContent(child);
                                            }
                                        }
                                    });
                                };
                                clearTextContent(newNode);

                                // 移除新节点的 uuid
                                if (newNode.hasAttribute("uuid")) {
                                    newNode.removeAttribute("uuid");
                                }

                                // 插入新节点
                                currentNode.parentNode.insertBefore(
                                    newNode,
                                    currentNode.nextSibling
                                );

                                // 获取新节点中最内层的元素位置
                                const getInnermostElement = (node) => {
                                    let current = node;
                                    while (
                                        current.firstElementChild &&
                                        current.firstElementChild.tagName !== "BR"
                                    ) {
                                        current = current.firstElementChild;
                                    }
                                    return current;
                                };

                                // 在最内层元素中添加 BR 标签（如果没有的话）
                                const innermost = getInnermostElement(newNode);
                                if (!innermost.querySelector("br")) {
                                    const br = document.createElement("br");
                                    innermost.appendChild(br);
                                }

                                // 更新 Quill 的内容
                                this.quill.update();

                                // 将光标移动到新行
                                const newIndex = range.index + newNode.textContent.length + 1;
                                this.quill.setSelection(newIndex, 0);
                            } else {
                                // 使用新逻辑 - 处理行中间的换行
                                const format = this.quill.getFormat(range);
                                const cursorPosition = range.index;

                                // 在光标位置插入换行
                                this.quill.insertText(cursorPosition, "\n", format);

                                // 更新 Quill 的内容
                                this.quill.update();

                                // 将光标移动到新行
                                this.quill.setSelection(cursorPosition + 1, 0);
                            }

                            // 处理高亮类的移除
                            const editor = this.quill.root;
                            const highlightElements =
                                editor.getElementsByClassName("highlight-active");
                            const highlightclickElements =
                                editor.getElementsByClassName("highlight-click");

                            Array.from(highlightElements).forEach((element) => {
                                if (
                                    element.nextSibling === null ||
                                    element.nextSibling.nodeType === Node.TEXT_NODE
                                ) {
                                    element.classList.remove("highlight-active");
                                }
                            });

                            Array.from(highlightclickElements).forEach((element) => {
                                if (
                                    element.nextSibling === null ||
                                    element.nextSibling.nodeType === Node.TEXT_NODE
                                ) {
                                    element.classList.remove("highlight-click");
                                }
                            });

                            return false;
                        }
                    },
                    "code-block-with-image": {
                        key: "enter",
                        handler(range) {
                            const [line] = this.quill.getLine(range.index);
                            const format = this.quill.getFormat(range);

                            if (format["code-block-with-image"]) {
                                this.quill.insertText(range.index, "\n");
                                return false;
                            }
                            return true;
                        }
                    }
                }
            },
            imageResize: {
                displaySize: true,
                modules: ["Resize"]
                // modules: ["Resize", "DisplaySize", "Toolbar"]
            },
            // "better-table": true, // 启用表格模块
            "better-table": {
                operationMenu: {
                    items: {
                        insertColumnRight: {
                            text: "右侧插入列"
                        },
                        insertColumnLeft: {
                            text: "左侧插入列"
                        },
                        insertRowUp: {
                            text: "上方插入行"
                        },
                        insertRowDown: {
                            text: "下方插入行"
                        },
                        deleteColumn: {
                            text: "删除列"
                        },
                        deleteRow: {
                            text: "删除行"
                        },
                        deleteTable: {
                            text: "删除表格"
                        }
                    }
                }
            },
            toolbar: {
                container: toolbarOptions,
                custom: [["formatBrush"]],
                handlers: {
                    "code-block-with-image": function () {
                        const range = this.quill.getSelection(true);
                        if (!range) return;

                        const format = this.quill.getFormat(range);
                        if (format["code-block-with-image"]) {
                            this.quill.format("code-block-with-image", false);
                        } else {
                            this.quill.format("code-block-with-image", true);
                        }
                    },
                    // 添加表格处理器
                    table: function () {
                        //   let tableModule = this.quill.getModule("better-table");
                        //   tableModule.insertTable(3, 3); // 第一个参数是行数，第二个参数是列数
                        const tableModule = this.quill.getModule("better-table");
                        tableModule.insertTable(3, 3);
                    },
                    size: function (value) {
                        const range = this.quill.getSelection(true); // true 参数会获取当前光标位置
                        if (range) {
                            if (range.length === 0) {
                                // 如果没有选中文本，获取当前光标所在的整行
                                const [line] = this.quill.getLine(range.index);
                                const lineLength = line.length();
                                const lineIndex = this.quill.getIndex(line);

                                // 设置整行的字体大小
                                this.quill.formatText(lineIndex, lineLength, "size", value);
                            } else {
                                // 如果选中了文本，只设置选中部分
                                this.quill.format("size", value);
                            }
                        }
                    },
                    header: function (value) {
                        const range = this.quill.getSelection();
                        if (range) {
                            // 首先移除 size 格式
                            this.quill.removeFormat("size", range.index, range.length);

                            // 然后设置 header
                            this.quill.format("header", value);

                            // 获取编辑器中的相关元素
                            setTimeout(() => {
                                const editor = this.quill.root;
                                const headerElements = editor.querySelectorAll(`h${value}`);

                                headerElements.forEach((element) => {
                                    // 移除内联的 font-size 样式
                                    element.style.removeProperty("font-size");

                                    // 同时处理内部所有子元素
                                    const children = element.getElementsByTagName("*");
                                    Array.from(children).forEach((child) => {
                                        child.style.removeProperty("font-size");
                                    });
                                });
                            }, 0);
                        }
                    },
                    // 自定义图标点击处理
                    "format-brush": function () {
                        // toggleActiveIcon(this.container.querySelector(".ql-format-brush"));
                        if (savedFormat) {
                            savedFormat = null;
                            const iconElement = this.container.querySelector(".ql-format-brush");
                            const toolbar = iconElement.closest(".ql-toolbar");
                            const activeIcons = toolbar.querySelectorAll(".active");
                            activeIcons.forEach((icon) => icon.classList.remove("active"));
                            iconElement.classList.remove("brashactive");
                            return;
                        }
                        // 获取当前选择的格式
                        const range = QUILL.getSelection();
                        if (range && range.length > 0) {
                            const iconElement = this.container.querySelector(".ql-format-brush");
                            const toolbar = iconElement.closest(".ql-toolbar");
                            const activeIcons = toolbar.querySelectorAll(".active");
                            activeIcons.forEach((icon) => icon.classList.remove("active"));
                            iconElement.classList.add("brashactive");

                            savedFormat = QUILL.getFormat(range); // 保存当前的格式
                        }
                        // 监听下一次选择的变化，并应用保存的格式
                        QUILL.on("selection-change", (range) => {
                            if (range && savedFormat && range.length > 0) {
                                // 首先应用块级样式（如 header）
                                // if (savedFormat.header) {
                                QUILL.formatLine(
                                    range.index,
                                    range.length,
                                    "header",
                                    savedFormat.header || 0
                                );
                                // }

                                // 然后应用行内样式（如 color 和自定义的 id-attribute）
                                if (savedFormat.color) {
                                    QUILL.formatText(
                                        range.index,
                                        range.length,
                                        "color",
                                        savedFormat.color
                                    );
                                }
                                if (savedFormat["id-attribute"]) {
                                    QUILL.formatText(
                                        range.index,
                                        range.length,
                                        "id-attribute",
                                        savedFormat["id-attribute"]
                                    );
                                }
                            }
                        });
                    },
                    image: handleImageUpload // 注册自定义图片上传处理函数
                }
            }
        },
        theme: "snow",
        // readOnly: iseditshow.value ? false : true, // 添加这一行来设置只读模式
        placeholder: "Compose an epic..."
    });
    QUILL.format("size", "16px"); // 设置默认字号
    addToolbarTitles();
    const headerSizeMap = {
        1: "26px",
        2: "22px",
        3: "16px",
        4: "14px"
    };
    // 监听选择变化
    // 监听选择变化
    QUILL.on("selection-change", function (range) {
        if (range) {
            const formats = QUILL.getFormat(range.index, range.length);

            // 获取字号选择器
            const sizePicker = document.querySelector(".ql-size");
            if (!sizePicker) return;

            // 如果当前位置是 heading
            if (formats.header) {
                const mappedSize = headerSizeMap[formats.header];
                if (mappedSize) {
                    // 移除之前的 active 状态
                    sizePicker
                        .querySelector(".ql-picker-label")
                        .setAttribute("data-value", mappedSize);
                    sizePicker.querySelector(".ql-picker-label").classList.add("ql-active");

                    // 更新下拉选项的选中状态
                    const options = sizePicker.querySelectorAll(".ql-picker-item");
                    options.forEach((option) => {
                        if (option.getAttribute("data-value") === mappedSize) {
                            option.classList.add("ql-selected");
                        } else {
                            option.classList.remove("ql-selected");
                        }
                    });
                }
            }
        }
    });
    const processLinks = (text) => {
        // 更新正则表达式以匹配完整的 URL，包括参数
        const urlRegex =
            /((?:https?:\/\/)?(?:www\.)?(?:[\w-]+\.)+[a-z]{2,}(?:\/[^\s\u4e00-\u9fa5，。,）)!;、'")}\]]*)?)/gi;

        // 将文本分割成段落
        const paragraphs = text.split("\n");

        // 处理每个段落
        const processedParagraphs = paragraphs.map((paragraph) => {
            let lastIndex = 0;
            let result = "";
            let match;

            // 使用正则表达式查找所有链接
            while ((match = urlRegex.exec(paragraph)) !== null) {
                const url = match[1];
                const start = match.index;

                // 添加链接前的文本
                result += paragraph.slice(lastIndex, start);

                // 添加链接
                result += `<a href="${url}" target="_blank">${url}</a>`;

                lastIndex = start + url.length;
            }

            // 添加剩余的文本
            result += paragraph.slice(lastIndex);
            return result;
        });

        return processedParagraphs.join("\n");
    };
    // QUILL.root.addEventListener("paste", handlePaste, true);
    // 4. 可选：添加全局粘贴拦截
    document.addEventListener(
        "paste",
        (e) => {
            // 检查是否在编辑器内粘贴
            if (e.target.closest(".ql-editor")) {
                const selection = QUILL.getSelection() || QUILL.selection.savedRange;
                const clipboardData = e.clipboardData;
                if (!clipboardData) {
                    return true;
                }

                const items = Array.from(clipboardData.items || []);

                // 剪贴板中的内容
                const text = clipboardData.getData("text/plain") || "";
                const html = clipboardData.getData("text/html") || "";
                const hasText = text.trim() !== "";
                const hasHtml = html.trim() !== "";

                // 检查是否包含图片
                const hasImage = items.some((item) => item.type.indexOf("image") !== -1);

                // 情况一：只包含图片（无文本/HTML），走自定义图片上传逻辑
                if (hasImage && !hasText && !hasHtml) {
                    e.preventDefault();
                    e.stopPropagation();
                    handlePaste(e);
                    return false;
                }

                // 情况二：在自定义代码块中粘贴，保留原有特殊处理
                if (selection) {
                    const [block] = QUILL.getLine(selection.index);
                    const isInCodeBlock =
                        block && block.domNode.classList.contains("ql-code-block-with-image");

                    if (isInCodeBlock) {
                        e.preventDefault();

                        // 获取当前代码块的范围
                        const blockStartIndex = QUILL.getIndex(block);

                        // 获取HTML和文本内容
                        const htmlInCode = clipboardData.getData("text/html");
                        const textInCode = clipboardData.getData("text/plain");

                        // 修改这里：如果有选中内容，先删除
                        if (selection.length > 0) {
                            QUILL.deleteText(selection.index, selection.length);
                        }

                        // 先插入文本内容
                        if (textInCode) {
                            QUILL.insertText(selection.index, textInCode, {
                                "code-block-with-image": true
                            });
                        }

                        // 从HTML中提取并插入图片
                        if (htmlInCode) {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(htmlInCode, "text/html");
                            const images = doc.getElementsByTagName("img");

                            Array.from(images).forEach((img) => {
                                QUILL.insertEmbed(selection.index, "image", img.src, {
                                    "code-block-with-image": true
                                });
                            });
                        }

                        // 确保整个块的格式正确
                        const currentLength = block.length();
                        QUILL.formatLine(
                            blockStartIndex,
                            currentLength,
                            "code-block-with-image",
                            true
                        );

                        return false;
                    }
                }

                // 情况三：普通内容粘贴
                // 1）如果有 HTML，直接让 Quill 以原始 HTML 粘贴，尽量还原原来的格式
                if (hasHtml) {
                    e.preventDefault();

                    const index =
                        selection && typeof selection.index === "number"
                            ? selection.index
                            : QUILL.getLength();

                    if (selection && selection.length > 0) {
                        QUILL.deleteText(selection.index, selection.length);
                    }

                    QUILL.clipboard.dangerouslyPasteHTML(index, html);
                    return false;
                }

                // 2）只有纯文本时，交给浏览器 / Quill 默认逻辑处理
                // 其他情况允许默认粘贴行为
                return true;
            }
        },
        true
    );

    // 记录初始化后的基准内容
    try {
        initialHtml = QUILL.getSemanticHTML();
    } catch (e) {
        initialHtml = content || "";
    }
    hasUserEdited = false;

    //监听改变事件
    QUILL.on("text-change", (delta, oldDelta, source) => {
        // op.attributes["id-attribute"] = null; // 去掉新段落的 UUID
        if (source === "user") {
            // 只要有用户编辑过，就标记为已修改
            hasUserEdited = true;
            const changes = delta.ops;
            changes.forEach((change) => {
                if (change.insert === "\n") {
                    // 获取编辑器根元素
                    const editor = QUILL.root;

                    // 找到所有带有 highlight-active 类的元素
                    const highlightElements = editor.getElementsByClassName("highlight-active");
                    const highlightclickElements = editor.getElementsByClassName("highlight-click");

                    // 移除最后一个元素的 highlight-active 类
                    Array.from(highlightElements).forEach((element) => {
                        if (
                            element.nextSibling === null ||
                            element.nextSibling.nodeType === Node.TEXT_NODE
                        ) {
                            element.classList.remove("highlight-active");
                        }
                    });
                    // 移除最后一个元素的 highlight-click 类
                    Array.from(highlightclickElements).forEach((element) => {
                        if (
                            element.nextSibling === null ||
                            element.nextSibling.nodeType === Node.TEXT_NODE
                        ) {
                            element.classList.remove("highlight-click");
                        }
                    });
                }
            });
            if (shouldAttemptAutoLink(delta)) {
                queueMicrotask(() => applyAutoLinkIfNeeded(QUILL));
            }
        }
    });
    // 等待 Quill 初始化完成后再设置图标
    nextTick(() => {
        if (Role === "1" || Role === "2") {
            // setupParagraphIcons();
        }
    });
    observer.observe(QUILL.root, { childList: true, subtree: true });
};
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            console.log(node.nodeName);

            // 检查是否为新添加的 <p> 标签
            if (["P", "PRE", "H1", "H2", "H3", "H4", "H5", "H6"].includes(node.nodeName)) {
                // 移除 uuid 属性
                if (node.hasAttribute("uuid")) {
                    node.removeAttribute("uuid");
                }

                // 移除 highlight-active 类名
                const highlightElements = node.getElementsByClassName("highlight-active");
                Array.from(highlightElements).forEach((element) => {
                    element.classList.remove("highlight-active");
                });

                // 如果 p 标签本身也有 highlight-active 类,也需要移除
                if (node.classList.contains("highlight-active")) {
                    node.classList.remove("highlight-active");
                }

                // 移除 highlight-click 类名
                const highlightclickElements = node.getElementsByClassName("highlight-click");
                Array.from(highlightclickElements).forEach((element) => {
                    element.classList.remove("highlight-click");
                });

                // 如果 p 标签本身也有highlight-click 类,也需要移除
                if (node.classList.contains("highlight-click")) {
                    node.classList.remove("highlight-click");
                }
            }
        });
    });
});

onMounted(() => {
    // 设置默认字号
    // const quill = quillEditorRef.value.getQuill();

    const Parchment = Quill.import("parchment");
    const Attributor = Quill.import("parchment").Attributor;

    const IDAttribute = new Attributor("id-attribute", "uuid", {
        scope: Parchment.Scope.BLOCK
    });

    Quill.register(
        {
            "attributors/attribute/uuid": IDAttribute
        },
        true
    );
    Quill.register(
        {
            "formats/uuid": IDAttribute
        },
        true
    );

    const Block = Quill.import("blots/block");

    class BlockBlot extends Block {
        constructor(domNode) {
            super(domNode);
            domNode.setAttribute("uuid", "");
            this.cache = {};
        }
    }

    BlockBlot.blotName = "block";
    geteditData();
    window.addEventListener("keydown", handleKeyDown);
});
onBeforeUnmount(() => {
    if (QUILL && QUILL.root) {
        QUILL.root.removeEventListener("paste", handlePaste);
    }
    removeHighlight();
    // 移除事件监听器
    window.removeEventListener("keydown", handleKeyDown);
});

const picloading = ref();
// 自定义Quill的图片上传功能
const handleImageUpload = () => {
    const fileInput = document.createElement("input");
    fileInput.setAttribute("type", "file");
    fileInput.setAttribute("accept", "image/*");
    fileInput.click();

    fileInput.onchange = async () => {
        const file = fileInput.files[0];
        let form = new FormData();
        form.append("file", file);
        let rangeIndex = QUILL.selection.lastRange.index;
        picloading.value = ElLoading.service({
            lock: true,
            text: "",
            background: "rgba(0, 0, 0, 0.7)"
        });

        // QUILL.blur();
        picAPI(form)
            .then((res) => {
                const imageUrl = res.data;
                QUILL.insertEmbed(rangeIndex, "image", imageUrl);
            })
            .catch((err) => {})
            .finally(() => {
                picloading.value.close();
            });
    };
};
const handlePaste = async (e) => {
    e.preventDefault(); // 阻止默认粘贴行为
    e.stopPropagation(); // 阻止事件冒泡
    const clipboardData = e.clipboardData;
    const items = clipboardData.items;

    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf("image") !== -1) {
            const file = item.getAsFile();
            let form = new FormData();
            form.append("file", file);

            // 获取当前光标位置
            let range = QUILL.getSelection();
            let rangeIndex = range ? range.index : 0;

            const loading = ElLoading.service({
                lock: true,
                text: "上传中...",
                background: "rgba(0, 0, 0, 0.7)"
            });

            try {
                const res = await picAPI(form);
                const imageUrl = res.data;
                QUILL.insertEmbed(rangeIndex, "image", imageUrl);
            } catch (error) {
                console.error("Upload failed:", error);
                ElMessage.error("图片上传失败");
            } finally {
                loading.close();
            }
            break;
        }
    }
};
// 使用 suspense 和异步组件
const geteditData = async () => {
    QUILL = null;
    // try {
    //     const res = await detailEditApi({ id: route.params.id, role: Role });
    //     if (res.code === 200) {
    EditData.value = props.quillcontent?.replace(/  /g, "&nbsp;&nbsp;");
    // oldHtml.value = res.data.content;
    setTimeout(() => {
        initQuill(props.quillcontent);
    }, 300);
    //     }
    // } catch (error) {
    //     console.error(error);
    // }
};
const describesure = async () => {
    // try {
    //     saveloaing.value = true;
    const Htmlvalue = QUILL.getSemanticHTML();

    //     const formD = {
    //         type: 1,
    //         id: route.params.id,
    //         newHtml: Htmlvalue,
    //         oldHtml: oldHtml.value,
    //         describe: describeinput.value
    //     };

    //     const res = await fileUpdate(formD);

    //     if (res.code === 200) {
    //         ElMessage.success("success");
    emits("changesavestate", Htmlvalue);
    //         describeinput.value = "";
    //         oldHtml.value = Htmlvalue;
    //     } else {
    //         ElMessage.error("failed");
    //     }
    // } catch (error) {
    //     console.error(error);
    //     ElMessage.error("An error occurred");
    // } finally {
    //     saveloaing.value = false;
    // }
};

// 对外暴露当前编辑内容，便于外层在关闭时做变更对比
const getContent = () => {
    if (QUILL) {
        return QUILL.getSemanticHTML();
    }
    return EditData.value || "";
};
// 对外暴露是否有修改（基于初始化时的内容）
const isModified = () => {
    if (!QUILL) return hasUserEdited;
    try {
        const current = QUILL.getSemanticHTML();
        return hasUserEdited && current !== initialHtml;
    } catch (e) {
        return hasUserEdited;
    }
};
const handleKeyDown = (event) => {
    // 检查是否同时按下 Ctrl 和 S
    if (event.ctrlKey && event.key === "s") {
        event.preventDefault(); // 防止浏览器默认的保存页面行为
        describesure();
    }
};
defineExpose({ describesure, getContent, isModified });
</script>
<style lang="scss" scoped>
.addmuludiv {
    display: flex;
    position: relative;
}

.quillclass {
    flex: 1;
    width: 85%;
}
.maincontent {
    height: calc(100vh - 400px);
}
.noneedit {
    // height: calc(100vh - 66px);
}
.inputmodel {
    /* padding: 0 20px; */

    /* left: 50%;
    transform: translateX(-50%); */
}
.save-button {
    width: 100px;
    background-color: #4caf50; /* 绿色背景 */
    color: white; /* 白色文字 */
}

.save-button:hover {
    background-color: #45a049; /* 悬停时的绿色 */
}
.downloadAsWord {
    position: fixed;
    transform: translate(0, 0);
    top: 3px;
    right: 140px;
    z-index: 9999999;
    cursor: pointer;
    text-decoration: underline;
    display: flex;
    align-items: center;
}

:deep .ql-editor {
    overflow-x: hidden;
}
.fa-paint-brush {
    color: aqua;
}
.container {
    display: flex;
    width: 100%;
    height: 100%;
    position: relative;
}

.quillclass {
    position: relative;
    min-width: 300px;
    height: 100%;
    overflow: auto;
}

.quilltoobarright {
    position: relative;
    // min-width: 150px;
    height: 100%;
    overflow: auto;
}

.resizer {
    width: 6px;
    background-color: #f0f0f0;
    cursor: col-resize;
    transition: background-color 0.3s;
    z-index: 1;
}

.resizer.hover,
.resizer:active {
    background-color: #a0a0a0;
}

/* 拖动时添加遮罩，防止内容被选中 */
.container.dragging::after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
}
</style>
